<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div class="col-md-12">
            <div class="card-header">
              <h4 class="card-title">ประวัติการสั่งซื้อ</h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-2">
              <div><label>เดือน</label></div>
              <a-month-picker
                v-model:value="month"
                placeholder="เลือกเดือน"
                :format="monthFormat"
                :allow-clear="false"
              />
            </div>
            <div class="col-md-2">
              <div><label>เกม</label></div>
              <a-select
                mode="multiple"
                v-model:value="selects.game"
                style="width: 100%"
                placeholder="เลือกเกม"
                v-if="selects.gameLoaded"
                :options="selects.games"
              />
            </div>
            <div class="col-md-2">
              <div><label>สถานะ</label></div>
              <a-select
                mode="multiple"
                v-model:value="selects.status"
                style="width: 100%"
                placeholder="เลือกสถานะ"
                v-if="selects.statusesLoaded"
                :options="selects.statuses"
              />
            </div>
            <div class="col-md-2">
              <div><label>เลขที่ใบสั่งซื้อ</label></div>
              <a-input
                v-model:value="orderNo"
                placeholder="เลขที่ใบสั่งซื้อ"
                v-on:keyup.enter="
                  manage ? getManageHistories() : getPurchaseHistories()
                "
                allow-clear
              />
            </div>
            <div class="col-md-2">
              <div><label style="color: transparent">ค้นหา</label></div>
              <a-button
                type="primary"
                @click="manage ? getManageHistories() : getPurchaseHistories()"
              >
                ค้นหา
              </a-button>
            </div>
          </div>
          <div class="row" v-if="manage">
            <div class="col-md-12 text-right">
              <a-button shape="round" @click="onExport"> ดาวน์โหลด </a-button>
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-md-12">
              <a-table
                :columns="columns"
                :data-source="data"
                :rowKey="record => record.id"
                :loading="historyLoaded"
                :scroll="{ x: 1200 }"
              >
                <template #orderNo="{ record }">
                  <router-link
                    v-bind:to="
                      (manage ? '/management/details/' : '/purchase/details/') +
                      record.id
                    "
                  >
                    {{ record.orderNo }}
                  </router-link>
                </template>
                <template #status="{ record }">
                  <a-select
                    v-model:value="record.status"
                    style="width: 100%"
                    @change="onChangeStatus(record.id, record.queueNo, record.status)"
                    placeholder="เลือกสถานะ"
                    :options="selects.statuses"
                  />
                </template>
              </a-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as configuration from "../../middleware/configuration";
import * as orderservice from "../../services/order";
import * as gameservice from "../../services/game";
import moment from "moment";
import { SearchOutlined, DownloadOutlined } from "@ant-design/icons-vue";
import { message } from "ant-design-vue";
const monthFormat = "MMM YYYY";
const dateNow = new Date();
const columns = [
  {
    title: "No",
    dataIndex: "no",
    key: "no",
    width: 65,
  },
  {
    title: "เลขที่ใบสั่งซื้อ",
    slots: { customRender: "orderNo" },
    key: "orderNo",
  },
  {
    title: "เกม",
    dataIndex: "gameName",
    key: "gameName",
  },
  {
    title: "แพ็คเกจ",
    dataIndex: "packageName",
    key: "packageName",
  },
  {
    title: "วันที่สั่งซื้อ",
    dataIndex: "purchaseDateStr",
    key: "purchaseDate",
  },
  {
    title: "ราคาสินค้า (บาท)",
    dataIndex: "price",
    key: "price",
  },
  {
    title: "Reference ID",
    dataIndex: "queueNo",
    key: "queueNo",
  },
  {
    title: "สถานะ",
    dataIndex: "statusStr",
    key: "statusStr",
    width: 100,
  },
];
const columns_manage = [
  {
    title: "No",
    dataIndex: "no",
    key: "no",
    width: 65,
  },
  {
    title: "เลขที่ใบสั่งซื้อ",
    slots: { customRender: "orderNo" },
    key: "orderNo",
  },
  {
    title: "เกม",
    dataIndex: "gameName",
    key: "gameName",
  },
  {
    title: "แพ็คเกจ",
    dataIndex: "packageName",
    key: "packageName",
  },
  {
    title: "วันที่สั่งซื้อ",
    dataIndex: "purchaseDateStr",
    key: "purchaseDate",
  },
  {
    title: "ราคาสินค้า (บาท)",
    dataIndex: "price",
    key: "price",
  },
  {
    title: "Reference ID",
    dataIndex: "queueNo",
    key: "queueNo",
  },
  {
    title: "สถานะ",
    slots: { customRender: "status" },
    key: "status",
    width: 150,
  },
];
export default {
  components: {
    SearchOutlined,
    DownloadOutlined,
  },
  methods: {
    async getPurchaseHistories() {
      this.historyLoaded = true;

      let data = {
        month: this.month,
        uid: this.uid,
        game: this.selects.game,
        status: this.selects.status,
        orderNo: this.orderNo,
      };

      try {
        let res = await orderservice.getPurchaseHistories("order", data);
        let count = 1;
        this.history = [];
        res.data.map((x) => {
          x.no = count++;
          x.purchaseDateStr = this.getDate(x.purchaseDate);
          this.history.push(x);
        });
        this.data = res.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.historyLoaded = false;
      }
    },
    async getManageHistories() {
      this.historyLoaded = true;

      let data = {
        month: this.month,
        game: this.selects.game,
        status: this.selects.status,
        orderNo: this.orderNo,
      };

      try {
        let res = await orderservice.getPurchaseHistories("manage", data);
        let count = 1;
        this.history = [];
        res.data.map((x) => {
          x.no = count++;
          x.purchaseDateStr = this.getDate(x.purchaseDate);
          this.history.push(x);
        });
        this.data = res.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.historyLoaded = false;
      }
    },
    async getGames() {
      try {
        let res = await gameservice.get("games");
        res.data.map((m) => {
          this.selects.games.push({ value: m.id, label: m.name });
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.selects.gameLoaded = true;
      }
    },
    async getOrderStatus() {
      try {
        let res = await orderservice.getOrderStatus();
        res.data.map((m) => {
          this.selects.statuses.push({ value: m.key, label: m.name });
          this.selects.status = ["waiting_payment"];
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.selects.statusesLoaded = true;
      }
    },
    getDate(value) {
      if (value) return moment(value).format("DD/MM/YYYY HH:mm:ss");
      return "";
    },
    async onChangeStatus(id, queueNo, status) {
      let data = {
        id: id,
        queueNo: queueNo,
        status: status,
        uid: this.uid,
      };

      try {
        let res = await orderservice.changeOrderStatus(data);
        message.success("บันทึกข้อมูลสำเร็จ");
      } catch (error) {
        message.error("บันทึกข้อมูลไม่สำเร็จ");
      }
    },
    onExport() {
      let headers = [];
      let data = this.history.map(x => x);
      if (this.history.length > 0) {
        headers = Object.keys(this.history[0]);
      }

      this.exportCSVFile(
        headers,
        data,
        "Export " + moment().toString("YYMMDDHHmm")
      );
    },
    convertToCSV(objArray) {
      var array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
      var str = "";

      for (var i = 0; i < array.length; i++) {
        var line = "";
        for (var index in array[i]) {
          if (line != "") line += ",";

          line += array[i][index];
        }

        str += line + "\r\n";
      }

      return str;
    },
    exportCSVFile(headers, items, fileTitle) {
      if (headers) {
        items.unshift(headers);
      }

      // Convert Object to JSON
      var jsonObject = JSON.stringify(items);

      var csv = "\ufeff" + this.convertToCSV(jsonObject);

      var exportedFilenmae = fileTitle + ".csv" || "export.csv";

      var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, exportedFilenmae);
      } else {
        var link = document.createElement("a");
        if (link.download !== undefined) {
          // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", exportedFilenmae);
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    },
    async init() {
      if (this.route !== this.currentRouteName) {
        this.route = this.currentRouteName;
        this.uid = await configuration.getUid();
        let result = await configuration.getIdTokenResult();
        if (result) {
          if (this.route === "Management Purchase History") {
            this.role = result.claims?.role || this.role;
            this.manage =
              this.role === "admin" ||
              this.role === "manager" ||
              this.role === "staff";
            if (
              this.role === "admin" ||
              this.role === "manager" ||
              this.role === "staff"
            ) {
              this.columns = columns_manage;
              this.getManageHistories();
            } else {
              this.columns = columns;
              this.getPurchaseHistories();
            }
          } else {
            this.manage = false;
            this.columns = columns;
            this.getPurchaseHistories();
          }
        }
      }
    },
  },
  data() {
    return {
      columns: columns,
      data: [],
      history: [],
      historyLoaded: false,
      uid: "",
      month: moment(dateNow, monthFormat),
      monthFormat: monthFormat,
      orderNo: "",
      selects: {
        games: [],
        game: [],
        gameLoaded: false,
        statuses: [],
        status: [],
        statusesLoaded: false,
      },
      route: "",
      role: "",
      manage: false,
    };
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
  },
  async beforeMount() {
    await this.getOrderStatus();
    await this.getGames();
  },
  async beforeUpdate() {
    this.init();
  },
};
</script>

<style>
</style>